import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { Template } from "../../../@types/template";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";
import { RootState } from "../../rootReducer";
import { selectUser } from "../../userAuthentication/selectors/selectUser";

export const createTemplate = createAsyncThunk(
  "templateCreate/createTemplate",
  async (name: string, { rejectWithValue, getState }) => {
    try {

      const state = getState() as RootState;

      const { data } = await axiosInstance.post(`${api.baseURL}form`, {
        name,
        sourceOrganization: state.userAuthentication.user?.sourceOrganization,
      });

      return data as Template;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
